import { Pool, spawn, Worker } from "threads";

// threads.js only applies its blob+importScripts CORS workaround for absolute
// URLs. A relative path is given to Worker() directly, and dedicated workers
// do not reliably follow the Rails 302 from /modelling_worker.js onto the
// digested webpack pack — so expose() never runs and spawn() times out.
const WORKER_INIT_TIMEOUT_MS = 30000

function modellingWorkerUrl() {
  const meta = typeof document !== "undefined"
    ? document.querySelector('meta[name="modelling-worker-url"]')
    : null
  const fromMeta = meta && meta.getAttribute("content")
  const path = fromMeta || "/modelling_worker.js"
  try {
    return new URL(path, window.location.origin).href
  } catch (_) {
    return path
  }
}

function createPool() {
  const hardware = (typeof navigator !== "undefined" && navigator.hardwareConcurrency) || 2
  const size = Math.min(4, hardware)
  return new Pool(
    () => spawn(new Worker(modellingWorkerUrl()), { timeout: WORKER_INIT_TIMEOUT_MS }),
    { size }
  )
}

let pool = null
function getPool() {
  if (!pool) {
    pool = createPool()
  }
  return pool
}

// Same queue/settled/completed/terminate surface as threads Pool, but workers
// are not spawned until the first task is queued. The application pack pulls
// this module in on every page (via Stimulus + the modelling barrel), and an
// eager Pool would start hardwareConcurrency workers immediately.
export const workerPool = {
  queue(task) {
    return getPool().queue(task)
  },
  settled(...args) {
    return getPool().settled(...args)
  },
  completed(...args) {
    return getPool().completed(...args)
  },
  terminate(...args) {
    return pool ? pool.terminate(...args) : Promise.resolve()
  }
}
